import './styles.sass';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { truncate } from 'lodash-es';

import BarVisualisation from 'components/Explorer/BarVisualisation';
import PublicationStatusFlags, { flagLabelsFor } from 'components/Shared/PublicationStatusFlags';
import ResearchOutput from 'components/Explorer/models/research_output';
import * as QueryParams from 'components/Explorer/models/query_params';
import useQueryParams from 'hooks/useQueryParams';

const DEFAULT_TITLE_LENGTH = 70; // Characters
const DEFAULT_VISIBLE_OUTPUTS_COUNT = 2;

const trackClick = (output) => {
  Analytics.trackEvent('highlights-open-details-page', { outputId: output.id });
};

const OutputsList = ({
  post,
  outputs,
  visible = false,
  visibleOutputsCount = DEFAULT_VISIBLE_OUTPUTS_COUNT,
  titleLength = DEFAULT_TITLE_LENGTH
}) => {
  const params = useQueryParams();

  if (!outputs.length) return null;

  const linkFor = (outputId) => ({
    search: QueryParams.searchFor(QueryParams.withShowDetails(params, outputId))
  });

  const visibleOutputs = visible ? outputs : outputs.slice(0, visibleOutputsCount);

  return (
    <table className="OutputsList">
      <caption className="visually-hidden">{I18n.t('Explorer.OutputsList.caption')}</caption>
      <thead className="visually-hidden">
        <tr>
          <th scope="col">{I18n.t('Explorer.OutputsList.attention_header')}</th>
          <th scope="col">{I18n.t('Explorer.OutputsList.title_header')}</th>
        </tr>
      </thead>
      <tbody>
        {visibleOutputs.map((raw) => {
          const output = new ResearchOutput(raw);
          const title = truncate(output.title, { length: titleLength, separator: /\W/ });
          const flags = flagLabelsFor(output);
          const onClick = () => trackClick(output);
          const detailsLabel = flags
            ? I18n.t('Explorer.OutputsList.view_details_flagged', { title, flags })
            : I18n.t('Explorer.OutputsList.view_details', { title });
          return (
            <tr key={`${post.id}-${output.id}`}>
              <td className="visualisation">
                <Link onClick={onClick} to={linkFor(output.id)} aria-label={detailsLabel}>
                  <BarVisualisation output={output} />
                </Link>
              </td>
              <td className="output">
                <Link onClick={onClick} to={linkFor(output.id)}>
                  <PublicationStatusFlags output={output} />
                  {title}
                </Link>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

OutputsList.propTypes = {
  post: PropTypes.object.isRequired,
  outputs: PropTypes.array.isRequired,
  visible: PropTypes.bool,
  visibleOutputsCount: PropTypes.number,
  titleLength: PropTypes.number
};

export default OutputsList;
